import { render, staticRenderFns } from "./FilesDisplay.vue?vue&type=template&id=53394ece&scoped=true&"
import script from "./FilesDisplay.vue?vue&type=script&lang=js&"
export * from "./FilesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FilesDisplay.vue?vue&type=style&index=0&id=53394ece&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53394ece",
  null
  
)

export default component.exports